var exports = {
  "D": "Heading__GnjjJL",
};

module.exports = exports;
